import { useState, useEffect } from 'react';
import { isLoggedIn as checkIsLoggedIn } from '../../authUtils'; // Adjust the path as needed

const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedInStatus = checkIsLoggedIn();
    setIsLoggedIn(loggedInStatus);
  }, []);

  return isLoggedIn;
};

export default useAuth;
